/**
 * Include your custom JavaScript here.
 *
 * We also offer some hooks so you can plug your own logic. For instance, if you want to be notified when the variant
 * changes on product page, you can attach a listener to the document:
 *
 * document.addEventListener('variant:changed', function(event) {
 *   var variant = event.detail.variant; // Gives you access to the whole variant details
 * });
 *
 * You can also add a listener whenever a product is added to the cart:
 *
 * document.addEventListener('product:added', function(event) {
 *   var variant = event.detail.variant; // Get the variant that was added
 *   var quantity = event.detail.quantity; // Get the quantity that was added
 * });
 *
 * If you are an app developer and requires the theme to re-render the mini-cart, you can trigger your own event. If
 * you are adding a product, you need to trigger the "product:added" event, and make sure that you pass the quantity
 * that was added so the theme can properly update the quantity:
 *
 * document.documentElement.dispatchEvent(new CustomEvent('product:added', {
 *   bubbles: true,
 *   detail: {
 *     quantity: 1
 *   }
 * }));
 *
 * If you just want to force refresh the mini-cart without adding a specific product, you can trigger the event
 * "cart:refresh" in a similar way (in that case, passing the quantity is not necessary):
 *
 * document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', {
 *   bubbles: true
 * }));
 */

/**
 * TargetCircle / TrackMyTarget — persist click IDs onto the cart.
 *
 * When a visitor lands with ?tmt_data=... (and optionally ?tmt_ufp=...), we:
 * 1) store values in localStorage (survives navigation within the session)
 * 2) write them as cart attributes so they become order note attributes
 *
 * Shopify Flow can then read tmt_data from the paid order as a Thank You page backup.
 */
(function () {
  var STORAGE_TMT = 'tc_tmt_data';
  var STORAGE_UFP = 'tc_tmt_ufp';
  var ATTR_TMT = 'tmt_data';
  var ATTR_UFP = 'tmt_ufp';

  function safeGet(key) {
    try {
      return window.localStorage.getItem(key) || '';
    } catch (e) {
      return '';
    }
  }

  function safeSet(key, value) {
    try {
      if (value) {
        window.localStorage.setItem(key, value);
      }
    } catch (e) {
      // Ignore private mode / storage blocked
    }
  }

  function readQueryParams() {
    try {
      return new URLSearchParams(window.location.search);
    } catch (e) {
      return new URLSearchParams();
    }
  }

  function resolveClickIds() {
    var params = readQueryParams();
    var fromQueryTmt = params.get('tmt_data') || params.get('tmtData') || '';
    var fromQueryUfp = params.get('tmt_ufp') || params.get('tmtUfp') || '';

    if (fromQueryTmt) safeSet(STORAGE_TMT, fromQueryTmt);
    if (fromQueryUfp) safeSet(STORAGE_UFP, fromQueryUfp);

    return {
      tmtData: fromQueryTmt || safeGet(STORAGE_TMT),
      tmtUfp: fromQueryUfp || safeGet(STORAGE_UFP)
    };
  }

  function needsUpdate(cart, tmtData, tmtUfp) {
    var attrs = (cart && cart.attributes) || {};
    var updateTmt = Boolean(tmtData) && attrs[ATTR_TMT] !== tmtData;
    var updateUfp = Boolean(tmtUfp) && attrs[ATTR_UFP] !== tmtUfp;
    return updateTmt || updateUfp;
  }

  function buildAttributes(existing, tmtData, tmtUfp) {
    var next = Object.assign({}, existing || {});
    if (tmtData) next[ATTR_TMT] = tmtData;
    if (tmtUfp) next[ATTR_UFP] = tmtUfp;
    return next;
  }

  function updateCartAttributes(tmtData, tmtUfp) {
    if (!tmtData && !tmtUfp) return;

    fetch('/cart.js', {
      credentials: 'same-origin',
      headers: { Accept: 'application/json' }
    })
      .then(function (response) {
        if (!response.ok) throw new Error('cart.js ' + response.status);
        return response.json();
      })
      .then(function (cart) {
        if (!needsUpdate(cart, tmtData, tmtUfp)) return null;

        return fetch('/cart/update.js', {
          method: 'POST',
          credentials: 'same-origin',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json'
          },
          body: JSON.stringify({
            attributes: buildAttributes(cart.attributes, tmtData, tmtUfp)
          })
        });
      })
      .catch(function () {
        // Non-blocking: attribution still handled by Custom Pixel cookies
      });
  }

  var ids = resolveClickIds();
  updateCartAttributes(ids.tmtData, ids.tmtUfp);
})();
